<template>
  <div class="loading">
    <span class="spinner"></span>
  </div>
</template>


<style lang="scss" scoped>
@import '@/assets/scss/colors.scss';

.loading {
  position: fixed;
  z-index: 999;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);

  .spinner {
    width: 48px;
    height: 48px;
    border: 5px solid $color-light;
    border-bottom-color: $color-primary-400;
    border-radius: 50%;
    display: inline-block;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;
  }

  @keyframes rotation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
}
</style>